<template>
    <v-container>
        <v-container class="pa-0 ls-add-status-alert">
            <v-alert
                v-model="alert.invoke"
                :type="alert.type"
                border="left"
                transition="slide-x-transition"
            >
                <v-row>
                    <v-col>
                        <span id="ID_EDIT_COMPANY_ALERT_TITLE" class="text-h5">
                            {{ alert.title }}
                        </span>
                        <v-divider class="mb-4" />
                        <span>{{ alert.message }}</span>
                    </v-col>
                </v-row>
                <v-row v-if="alert.closeManually" class="justify-center">
                    <v-btn id="ID_EDIT_COMPANY_ALERT_BUTTON_CLOSE" @click="closeAlert()">
                        Закрыть
                    </v-btn>
                </v-row>
            </v-alert>
        </v-container>

        <p id="ID_TITLE_ADD_COMPANY" class="headline">Редактирование компании</p>

        <v-container fluid>
            <v-form ref="form" lazy-validation>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            id="ID_EDIT_COMPANY_GUID"
                            v-model="company.guid"
                            :rules="[(v) => !!v || 'Требуется ввести GUID компании']"
                            label="GUID компании"
                            readonly
                            required
                        ></v-text-field>

                        <v-text-field
                            id="ID_EDIT_COMPANY_NAME"
                            v-model="company.name"
                            :rules="[(v) => !!v || 'Требуется ввести наименование компании']"
                            label="Наименование компании"
                            required
                        ></v-text-field>

                        <v-text-field
                            id="ID_EDIT_COMPANY_DESCRIPTION"
                            v-model="company.description"
                            :rules="[(v) => !!v || 'Требуется ввести описание для компании']"
                            label="Описание компании"
                            required
                        ></v-text-field>

                        <v-switch
                            id="ID_EDIT_COMPANY_READONLY"
                            v-model="company.readonly"
                            hide-details
                            label="Тип взаимодействия: Управляемая компания / Только статистика"
                        ></v-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6"></v-col>
                    <v-col class="d-flex justify-end mb-6" cols="12" sm="6">
                        <v-btn
                            id="ID_EDIT_COMPANY_BUTTON_UPDATE"
                            :disabled="waitForResponse"
                            class="mr-2"
                            color="success"
                            @click.stop="clickOnUpdateCompanyButton()"
                        >
                            Обновить
                        </v-btn>

                        <v-btn
                            id="ID_EDIT_COMPANY_BUTTON_CANCEL"
                            class="mr-2"
                            color="info"
                            @click="clickOnCancelButton()"
                        >
                            Отменить
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </v-container>
</template>

<script type="text/javascript">
    import CompaniesDataService from "../../services/CompaniesDataService";
    import { v4 as uuidv4 } from "uuid";

    export default {
        name: "company-edit",
        data: () => ({
            companyId: -1,
            usedCompaniesGuids: [],
            alert: {
                invoke: false,
                closeManually: false,
                type: "info", //v-alert type prop
                title: "",
                message: "",
            },
            company: {
                guid: "",
                name: "",
                description: "",
                readonly: false,
            },
            uniquePciPortForDevice: true,
            waitForResponse: false,
        }),
        created() {
            this.getUsedFieldValues();
            let companyUid = uuidv4();
            this.company.guid = companyUid;
        },
        methods: {
            clickOnUpdateCompanyButton() {
                if (this.$refs.form.validate()) {
                    this.waitForResponse = true;
                    let data = {
                        id: this.companyId,
                        guid: this.company.guid,
                        name: this.company.name,
                        description: this.company.description,
                        readonly: this.company.readonly,
                    };

                    CompaniesDataService.update(this.companyId, data)
                        .then((response) => {
                            this.company.id = response.data.id;
                            this.setSuccessAlert(
                                "Обновление успешно выполнено",
                                "Компания " + this.company.name + " обновленна",
                            );
                            this.alert.invoke = true;
                            const closeTimeoutMs = 4000;
                            this.closeAlert(closeTimeoutMs);
                            this.getUsedFieldValues();
                        })
                        .catch((e) => {
                            this.setErrorAlert("Не удалось обновить компанию", e);
                            this.alert.invoke = true;
                        });
                }
            },

            clickOnCancelButton() {
                this.$router.push("/companies");
            },

            getCompany(id) {
                console.info("Invoked getCompany with id:", id);
                CompaniesDataService.get(id)
                    .then((response) => {
                        this.company = response.data;
                        console.info("get company result is:", response.data);
                    })
                    .catch((e) => {
                        console.error("Can't get company data: ", e);
                    });
            },

            /* Alerts */
            clearAlert() {
                this.alert.invoke = false;
                this.alert.closeManually = false;
                this.alert.title = "";
                this.alert.message = "";
            },

            setErrorAlert(title = "Ошибка", message = "") {
                this.alert.type = "error";
                this.alert.closeManually = true;
                this.alert.title = title;
                this.alert.message = message;
            },

            setSuccessAlert(title = "Успех", message = "") {
                this.alert.type = "success";
                this.alert.closeManually = false;
                this.alert.title = title;
                this.alert.message = message;
            },

            closeAlert(delay) {
                setTimeout(() => {
                    this.waitForResponse = false;
                    this.clearAlert();
                }, delay);
            },

            //Validation
            getUsedFieldValues() {
                this.usedCompaniesGuids = [];
                CompaniesDataService.getAll()
                    .then((response) => {
                        const companies = response.data;
                        console.info("Received companies is:", companies);
                        companies.forEach((item) => {
                            this.usedCompaniesGuids.push(item.guid);
                        });
                    })
                    .catch((exception) => {
                        console.error(
                            "Error while receiving used field values. Reason: ",
                            exception.message,
                        );
                    });
            },

            isCompaniesGuidsAlreadyExists(guid) {
                return !this.usedCompaniesGuids.includes(guid);
            },
        },
        beforeCreate() {
            let client = this.$http.createClient();
            CompaniesDataService.setHttpClient(client);
        },
        mounted() {
            this.getCompany(this.$route.params.id);
            this.companyId = this.$route.params.id;
        },
    };
</script>

